import type { FeatureRoute } from '../types';
import { FoodpandaPage } from './FoodpandaPage';

/** Routes owned by this feature (paths are relative to the app root). */
export const routes: FeatureRoute[] = [{ path: 'foodpanda', element: <FoodpandaPage /> }];
